import { PlaybackEvent, PlaybackEventEmitter, PositionTimeUnit, PositionType } from '@annunciate/core';
import { useCallback, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { messageFactory, Topic, } from '@annunciate/core';
import { usePlaying } from './usePlaying';
export const useOnScrub = () => {
    const { playing } = usePlaying();
    const [leading, setLeading] = useState();
    const setLeadingOrFlush = useCallback((next) => {
        if (leading) {
            const start = leading.start;
            setLeading(undefined);
            messageFactory(Topic.PLAYBACK_SEEK, {
                ...next,
                start,
            });
        }
        else {
            setLeading(next);
        }
    }, [!!leading]);
    const onDebouncedScrubEvent = useDebouncedCallback((partial) => setLeadingOrFlush(partial), 2000, { leading: true, trailing: true });
    const onScrub = useCallback(async (from, to) => {
        if (!playing)
            return;
        const now = (new Date()).toISOString();
        const toPosition = {
            type: PositionType.TIME,
            unit: PositionTimeUnit.SECONDS,
            value: to,
        };
        await PlaybackEventEmitter.emit(PlaybackEvent.SCRUB, {
            content: playing,
            to: toPosition,
        });
        onDebouncedScrubEvent({
            item: {
                type: 'content',
                id: playing.id,
            },
            start: {
                timestamp: now,
                position: from,
            },
            end: {
                timestamp: (new Date()).toISOString(),
                position: to,
            },
        });
    }, [
        playing?.id,
    ]);
    return onScrub;
};
//# sourceMappingURL=useOnScrub.js.map